import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import TabPane from './TabPane';
import { emptyFn } from '../../utils/helper';
import { ActiveTabIdContext } from './context';
import { consumeTheme } from '../../utils/theme';
var TabPaneElementType = (h(TabPane, null)).type;
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentActiveId: _this.props.defaultActiveId
        };
        _this.activeTabItemRef = React.createRef();
        _this.indicatorRef = React.createRef();
        _this.containerRef = React.createRef();
        _this.selectTab = function (id) {
            if (id === _this.activeId) {
                return;
            }
            _this.setState({ currentActiveId: id });
            _this.props.onChange(id);
        };
        _this.handleResize = function () {
            _this.updateIndicator(true);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, tabBarStyle = _a.tabBarStyle, tabBarItemStyle = _a.tabBarItemStyle, indicatorStyle = _a.indicatorStyle, alignment = _a.alignment, activeItemStyle = _a.activeItemStyle, activeItemClassName = _a.activeItemClassName, indicatorClassName = _a.indicatorClassName, tabBarClassName = _a.tabBarClassName, tabBarItemClassName = _a.tabBarItemClassName, tabBarAdditionalContent = _a.tabBarAdditionalContent, contentClassName = _a.contentClassName, contentStyle = _a.contentStyle;
            var activeId = _this.activeId;
            var classes = classNames(prefixCls, className);
            var tabBarContent = React.Children.map(children, function (child) {
                var _a;
                if (child.type !== TabPaneElementType) {
                    return null;
                }
                var _b = child.props, id = _b.id, tab = _b.tab, icon = _b.icon, activeIcon = _b.activeIcon;
                var isActive = id === activeId;
                var tabBarItemClasses = classNames(prefixCls + "-bar-item", tabBarItemClassName, isActive && activeItemClassName, (_a = {},
                    _a[prefixCls + "-bar-item-active"] = isActive,
                    _a));
                var itemStyle = __assign(__assign({}, tabBarItemStyle), (isActive ? activeItemStyle : null));
                var effectiveIcon = isActive ? activeIcon || icon : icon;
                return (h("li", { className: tabBarItemClasses, style: itemStyle, key: id, onClick: function () { return _this.selectTab(id); }, ref: isActive ? _this.activeTabItemRef : function () { return null; } },
                    effectiveIcon ?
                        typeof effectiveIcon === 'string' ?
                            h("span", { className: classNames(prefixCls + "-icon"), style: { backgroundImage: "url(\"" + effectiveIcon + "\")" } })
                            : effectiveIcon
                        : null,
                    tab));
            });
            var tabBarClasses = classNames(prefixCls + "-bar", tabBarClassName, prefixCls + "-bar-" + alignment);
            var contentClasses = classNames(prefixCls + "-content", contentClassName);
            return (h("div", { className: classes, style: style },
                h("div", { style: { position: 'relative' } },
                    h("ul", { className: tabBarClasses, style: tabBarStyle }, tabBarContent),
                    h("div", { className: classNames(prefixCls + "-indicator", indicatorClassName), style: indicatorStyle, ref: _this.indicatorRef }),
                    tabBarAdditionalContent),
                h("div", { className: contentClasses, style: contentStyle, ref: _this.containerRef },
                    h(ActiveTabIdContext.Provider, { value: activeId }, children))));
        };
        return _this;
    }
    Object.defineProperty(Tabs.prototype, "activeId", {
        get: function () {
            return this.props.activeId || this.state.currentActiveId;
        },
        enumerable: false,
        configurable: true
    });
    Tabs.prototype.updateIndicator = function (skipAnimation) {
        if (skipAnimation === void 0) { skipAnimation = false; }
        var activeItemDom = this.activeTabItemRef.current;
        var indicatorDom = this.indicatorRef.current;
        if (!activeItemDom || !indicatorDom) {
            return;
        }
        var targetLeft = activeItemDom.offsetLeft, targetWidth = activeItemDom.offsetWidth;
        var indicatorWidth = this.props.indicatorWidth;
        var width = typeof indicatorWidth === 'number' ? indicatorWidth : targetWidth;
        indicatorDom.style.left = targetLeft + (targetWidth - width) / 2 + "px";
        indicatorDom.style.width = width + "px";
        if (skipAnimation) {
            indicatorDom.style.transition = 'none';
            setTimeout(function () {
                indicatorDom.style.removeProperty('transition');
            }, 0);
        }
    };
    Tabs.prototype.componentDidUpdate = function () {
        this.updateIndicator();
    };
    Tabs.prototype.componentDidMount = function () {
        this.updateIndicator(true);
        window.addEventListener('resize', this.handleResize);
    };
    Tabs.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    Tabs.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Tabs;
}(React.Component));
export default Tabs;
Tabs.defaultProps = {
    prefixCls: 'dui-m-tabs',
    onChange: emptyFn,
    defaultActiveId: '',
    alignment: 'center',
};
